export const cssBundleHref = "/build/css-bundle-BMQX2K6M.css";